import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import type { LocaleConfig } from './config';
import { isAppLanguage } from './isAppLanguage';
import { type AppLanguage, appLanguages, supportedAppLanguagesNames } from './supported-app-languages-names';

dayjs.extend(localizedFormat);
dayjs.locale('en');

type Locale = 'en' | 'es';

const dayjsLocales: Record<AppLanguage, LocaleConfig<Locale>> = {
  [appLanguages.english]: {
    locale: 'en',
    name: supportedAppLanguagesNames[appLanguages.english].name,
  },
  [appLanguages.spanish]: {
    locale: 'es',
    name: supportedAppLanguagesNames[appLanguages.spanish].name,
  },
};

export const useDateDayjsLocaleEffect = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const locale = isAppLanguage(i18n.language)
      ? dayjsLocales[i18n.language].locale
      : dayjsLocales[appLanguages.english].locale;

    dayjs.locale(locale);
  }, [i18n.language]);
};
